<template>
  <div class="sort">
    <Icon type="md-arrow-dropup" :class="{act:isStatus&&(status=='asc')}" @click="act('asc')"/>
    <Icon type="md-arrow-dropdown" :class="{act:isStatus&&(status=='desc')}" @click="act('desc')"/>
  </div>
</template>
<script>
export default {
    data(){
        return{
            status:'none'
        }
    },
    computed:{
        isStatus(){
            return this.keySort == this.inkeySort
        }
    },
    props:['keySort','inkeySort'],
    methods: {
        act(data){
            this.status = data
            // console.log(this.status)
            // this.$set(status,data)
            this.$emit('sort',{status:data,key:this.keySort})
        }
    },
};
</script>
<style lang="css" scoped>
.sort {
  display: inline-block;
  width: 20px;
  vertical-align: middle;
}
.sort i {
  line-height: 12px;
  font-size: 20px;
  margin: 0;
  padding: 0;
  float: left;
  /* border: 1px solid red; */
  cursor: pointer;
}
.sort i.act {
  color: #95f88e;
}
</style>


// WEBPACK FOOTER //
// src/components/sort.vue